import * as React from 'react';
import { FC } from 'react';

import { ActionButtonVariants } from 'components/action-button';

import { ILoyaltyButtonArrayWidgetFragment } from '../../../../generated/sanity-graphql';

import { StyledButton, StyledWrapper } from './loyalty-button-array-widget.styled';

export interface ILoyaltyButtonArrayWidgetProps extends ILoyaltyButtonArrayWidgetFragment {}

const ActionButtonMap = {
  PRIMARY: ActionButtonVariants.PRIMARY,
  OUTLINE: ActionButtonVariants.OUTLINE,
  INVERSE: ActionButtonVariants.INVERSE,
  BOX_SHADOW_INVERSE: ActionButtonVariants.BOX_SHADOW_INVERSE,
  BOX_SHADOW_PRIMARY: ActionButtonVariants.BOX_SHADOW_PRIMARY,
  TEXT_ONLY: ActionButtonVariants.TEXT_ONLY,
};

const LoyaltyButtonArrayWidget: FC<React.PropsWithChildren<ILoyaltyButtonArrayWidgetProps>> = ({
  buttons,
}) => {
  return (
    <StyledWrapper>
      {/* @ts-expect-error TS(2339) FIXME: Property 'type' does not exist on type '({ readonl... Remove this comment to see the full error message */}
      {buttons?.map(({ type = 'OUTLINE', link: linkProp }, idx) => {
        const { text, link } = linkProp;
        return (
          <StyledButton
            key={idx}
            testID="button-widget"
            to={link?.locale || ''}
            variant={type ? ActionButtonMap[type] : ActionButtonVariants.OUTLINE}
          >
            {text?.locale || ''}
          </StyledButton>
        );
      })}
    </StyledWrapper>
  );
};

export default LoyaltyButtonArrayWidget;
